module.exports = __webpack_public_path__ + "img/logo-cc-tu.ad7eb297.png";